import React, { FC } from 'react'
import Button from '../../../components/Button'
import { plannedCartTotal } from '../../../common/orders'
import { IBranch } from '../../../types/user'

interface IShoppingCartForecastProps {
  branch: IBranch
  updating: boolean
  onAddToOrder: () => void
}

const ShoppingCartForecast: FC<IShoppingCartForecastProps> = ({
  branch,
  updating,
  onAddToOrder,
}) => {
  if (!branch.suggestedCartItems || branch.suggestedCartItems.length === 0) {
    return null
  }

  const currentMonth = new Date().toLocaleString('en-US', { month: 'long' })

  return (
    <div className="order-modal_forecast">
      <div className="order-modal_forecast_info">
        <div className="order-modal_forecast_info_text">
          <div className="order-modal_forecast_info_text_title">
            {branch.suggestedCartItems.length} items ({plannedCartTotal(branch)})
          </div>
          <div className="order-modal_forecast_info_text_subtitle">
            {`suggested to order in ${currentMonth}`}
          </div>
        </div>

        <Button
          type="submit"
          color="primary"
          disabled={updating}
          className="order-modal_forecast_button"
          onClick={onAddToOrder}
        >
          Add to order
        </Button>
      </div>

      <div className="order-modal_forecast_separated"></div>

      <div className="order-modal_forecast_info_note">
        <div className="order-modal_forecast_info_note_text">
          *{' '}
          {`suggestion is based on the replenishment plan you've put together for ${currentMonth}`}
        </div>
      </div>
    </div>
  )
}

export default ShoppingCartForecast
